<template>
    <div class="card card-with-shadow border-0 h-100 upcoming-birthdays">
        <app-overlay-loader v-if="preloader"/>
        <div class="card-body" :class="{'loading-opacity': preloader}">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 class="mb-0">Upcoming Birthdays</h5>
                <span class="birthday-cake" aria-hidden="true">🎂</span>
            </div>

            <div v-if="birthdays.length">
                <div v-for="(person, index) in birthdays"
                     :key="person.id"
                     class="d-flex align-items-center birthday-row"
                     :class="{'birthday-today': person.is_today}">
                    <div class="birthday-avatar mr-3">
                        <img v-if="person.photo" :src="person.photo" :alt="person.name"/>
                        <span v-else :style="{ backgroundColor: avatarColor(index) }">{{ initials(person.name) }}</span>
                    </div>
                    <div class="flex-grow-1 min-width-0">
                        <p class="mb-0 text-truncate birthday-name">{{ person.name }}</p>
                        <p v-if="person.designation" class="mb-0 text-muted text-size-12 text-truncate">
                            {{ person.designation }}
                        </p>
                    </div>
                    <span class="badge text-size-12 ml-2"
                          :class="person.is_today ? 'badge-warning' : 'badge-light'">
                        {{ whenLabel(person) }}
                    </span>
                </div>
            </div>

            <div v-else class="text-center text-muted py-5">
                <div class="birthday-cake-empty mb-2" aria-hidden="true">🎂</div>
                <p class="mb-0 text-size-14">No birthdays in the next 30 days</p>
            </div>
        </div>
    </div>
</template>

<script>
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD} from "../../../../Config/ApiUrl";

export default {
    name: "UpcomingBirthdays",
    data() {
        return {
            preloader: false,
            birthdays: [],
            palette: ['#2563eb', '#10b981', '#f97316', '#a78bfa', '#60a5fa', '#ef4444'],
        }
    },
    created() {
        this.getUpcomingBirthdays();
    },
    methods: {
        getUpcomingBirthdays() {
            this.preloader = true;
            axiosGet(`${APP_DASHBOARD}/upcoming-birthdays`).then(({data}) => {
                this.birthdays = data || [];
            }).finally(() => {
                this.preloader = false;
            })
        },
        initials(name) {
            if (!name) return '?';
            return name.trim().split(/\s+/).slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('');
        },
        avatarColor(index) {
            return this.palette[index % this.palette.length];
        },
        whenLabel(person) {
            if (person.is_today) return '🎉 Today';
            if (person.days_until === 1) return 'Tomorrow';
            if (person.days_until <= 7) return `in ${person.days_until} days`;
            return person.date;
        },
    },
}
</script>

<style scoped>
.birthday-row {
    padding: 10px 8px;
    border-radius: 8px;
}

.birthday-row + .birthday-row {
    border-top: 1px solid var(--default-border-color);
}

.birthday-today {
    background-color: rgba(249, 115, 22, 0.07);
    border-top: none !important;
}

.birthday-name {
    font-weight: 500;
}

.birthday-avatar {
    width: 40px;
    height: 40px;
    flex: none;
}

.birthday-avatar img,
.birthday-avatar span {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 600;
    font-size: 13px;
}

.birthday-cake {
    font-size: 20px;
}

.birthday-cake-empty {
    font-size: 34px;
    opacity: 0.4;
}

.min-width-0 {
    min-width: 0;
}
</style>
